/* @flow */
import React from 'react';
import cx from 'classnames';

import s from './InputWithIcon.styl';

/**
 * TODO:
 * Not sure what I think of the className API i've created here. Specifying
 * <InputWithIcon className={...} /> actually sets the class on the top level
 * element. This seems fine, but it is also in contrast to passing all other
 * native props down through to the actual input.
 */
type InputWithIconProps = {
  id: string,
  icon: string,
  className?: string,
  placeholder: string,
};

export class InputWithIcon extends React.Component {
  props: InputWithIconProps;

  render() {
    const { icon, className, ...childProps } = this.props;
    const classes = cx(className, s.InputWithIcon, 'InputWithIcon');
    return (
      <div className={classes}>
        <label htmlFor={this.props.id}>
          <i className={cx('fa', icon)}></i>
        </label>
        <input {...childProps} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./web_modules/trustar/components/InputWithIcon.js